import { AMERICAN_MORTGAGE_LIMITS } from "shared/CalculatorLimits";
import { getAmountField } from "web_myplann/Calculators/Forms/getAmountField";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { z } from "zod";

export const getAmericanMortgageFormSchema = (t: TranslateFunction) =>
	z.object({
		propertyPrice: getAmountField(t, {
			min: AMERICAN_MORTGAGE_LIMITS.propertyPriceMin,
			max: AMERICAN_MORTGAGE_LIMITS.propertyPriceMax,
		}),
		years: z.number(),
		loanValue: z.number(),
	});
